<template>
  <div class="p-partyBuilding">
    <div class="g-box">
      <div class="box1">
        <div class="box1_nav">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div
              class="left_img m-h"
              :style="{ backgroundImage: 'url(' + item.image + ')' }"
            ></div>
            <div class="right_nav">
              <router-link
                :to="'/article_details/' + item.id"
                class="right_nav_title"
              >
                {{ item.title }}
              </router-link>
              <p class="right_nav_time">{{ item.tips }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="box2"
        :style="{
          backgroundImage: 'url(' + buildingImg + ')',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {
      buildingImg: "",
    };
  },
  methods: {
    async init() {
      this.params = this.$route.params;
      this.getAjax();

      this.buildingImg = await this.getMenuConfig("党建专栏Banner", "image");
    },

    getAjax() {
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.p-partyBuilding {
  position: relative;
  width: 100%;
  height: 1500px;
  background: url("~@/assets/img/news/background.png") no-repeat center top;
  background-size: cover;
}
.g-box {
  position: absolute;
  left: 50%;
  top: 280px;
  margin-left: -550px;
  width: 1100px;
}
.box1 {
  width: 1100px;
  height: 560px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(211, 0, 2, 0.1);
  overflow: hidden;
}
.box2 {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  width: 1100px;
  height: 500px;
}
.item {
  display: flex;
  margin-top: 40px;
  .left_img {
    margin-right: 20px;
    width: 180px;
    height: 120px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.right_nav_title {
  display: inline-block;
  width: 290px;
  height: 54px;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 27px;
}
.right_nav_time {
  width: 145px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #656878;
  line-height: 20px;
  margin-top: 20px;
}
.box1_nav {
  margin: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
  .item:hover {
    background: #f2f4f9;
  }
}
.right_img {
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
  width: 730px;
}
</style>
